import { DATE, formatDateNonUTC } from '../../../utils/date';
import { AgentResponse } from '../types';
import { DataContainer } from './DataContainer';
import { Gutter } from './Gutter';

export const AgentResponseContainer = ({ data }: { data: AgentResponse }) => {
  const { timestamp, message } = data;
  return (
    <div className='d-flex mb-3' style={{ animation: 'fadeIn 0.5s ease-in-out' }}>
      <Gutter />
      <div className='ms-auto text-right overflow-hidden' style={{ minWidth: '50%' }}>
        <div className='message-content mb-0'>{message}</div>
        <DataContainer data={data.data} />
        <div className='text-right text-ThemeTextLight justify-content-between mb-1'>
          <small>{formatDateNonUTC(timestamp, DATE.HUMANIZE)}</small>
        </div>
      </div>
      <Gutter right={true} icon={true}>
        <i className='fas fa-check text-success fa-lg' />
      </Gutter>
    </div>
  );
};
